<template>
  <div class="body">
      <Headtow></Headtow>
      <Headfor></Headfor>
      <div id="w-center">
        <div class="index_pub_title">
            <p class="pub_d_title">图书内容</p>
            <router-link  :to="`/index`"  class="pub_duo pub_duo_d">
               <i class="el-icon-house size-icon"></i> 首页>图书内容
            </router-link>
            <div class="pub_xian"></div>
        </div>

        <div id="content">
            <li class="tsg_li_dz bookcontleft" >
              <div class="img_div ">

                <img src="/static/img/gbj.png" alt="" class="dz_li_img" v-if="info.picarr ==''" :title="info.title">

                    <el-carousel  v-else >
                        <el-carousel-item v-for="item in info.picarr" :key="item">
                          <img :src="item" alt="" class="dz_li_img"  :title="info.title">
                        </el-carousel-item>
                      </el-carousel>

                    <p class="img_div_title">{{info.title}}</p>
              </div>
            </li>
            <div class="left">
              <p class="bookCont_title">{{info.title}}</p>
              <div class="bookCont_j">
                <p class="bookCont_a"><span>书号：</span>{{info.tm}} </p>
                <p class="bookCont_a"><span>出版社：</span>{{info.cbs}}  </p>
              </div>

              <div class="bookCont_j">
                <p class="bookCont_a"><span>作者：</span>{{info.zz}} </p>
                <p class="bookCont_a"><span>出版日期：</span>{{info.cbrq}}  </p>
              </div>

              <div class="bookCont_j">
                <p class="bookCont_a"><span>类别：</span>{{info.ztfl}} </p>
              </div>

              <div class="tj_money" style="font-size: 20px;font-weight: bold;">￥{{info.old_price}}</div>
              <div style="display: flex;margin-top: 20px;">
                <el-input-number v-model="num" @change="handleChange" :min="1" label="描述文字"></el-input-number>
                <div @click="handleClick(info.id,1)" class="gwc_a"> <i class="el-icon-shopping-cart-full gwc_c"></i>加入购物车</div>
              </div>

            </div>
            <div class="clear"></div>
        </div>
      </div>
       <Foot></Foot>
  </div>

</template>

<script>
import headtow from '@/components/public/headtow.vue';
import headfor from '@/components/public/headfor.vue'
import foot from '@/components/public/foot.vue'
export default{
  data(){
    return {
      loading:true,
      info:[],
      left:[],
       num: 1,
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Headfor': headfor,
    'Foot': foot,
  },
  mounted(){
    this.id = this.$route.query.id;
    this.recordapi();
  },
  methods:{

     handleChange(value) {
      console.log(value);
    },


    recordapi(){
        var that = this;

        that.$api.post("/index/bookcont",{'id':that.id}).then(res => {
          console.log(res);
          that.info= res.info;
          that.loading = false
        });
    },

    handleClick(index,e) {
      if(e == 2){
        if(this.radio=='0'){
          this.$message.error('请选择订单');
          return;
        }
      }
      var that = this;
      var row = index;
      var userid = that.$cookieStore.getCookie('userid');
      that.$api.post("/Goods/buy",{'gid':row,'num':this.num,'userid':userid,'status':'cart','gordernumber':0}).then(res => {
        console.log(res);

        if(res.code==1){
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }
      });


    },

  }

 }
</script>



// WEBPACK FOOTER //
// src/components/Bookcont.vue